import { render, staticRenderFns } from "./CVVideo.vue?vue&type=template&id=96683994&"
import script from "./CVVideo.vue?vue&type=script&lang=ts&"
export * from "./CVVideo.vue?vue&type=script&lang=ts&"
import style0 from "./CVVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports